export enum SharingLevel {
	Organisation = 0,
	Private = 1,
	UserGroups = 2
}
